import { IGetCepUseCase } from "../../../presentation/useCases/read/get_cep_use_case";
import { Cep } from "../../models/cep";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetCepUseCase
 */

export class GetCepUseCase implements IGetCepUseCase {
  private _dict = {
    "AC": "ACRE",
    "AL": "ALAGOAS",
    "AP": "AMAPA",
    "AM": "AMAZONAS",
    "BA": "BAHIA",
    "CE": "CEARA",
    "DF": "DISTRITO FEDERAL",
    "ES": "ESPIRITO SANTO",
    "EX": "ESTRANGEIRO",
    "GO": "GOIAS",
    "MA": "MARANHAO",
    "MT": "MATO GROSSO",
    "MS": "MATO GROSSO DO SUL",
    "MG": "MINAS GERAIS",
    "PA": "PARA",
    "PB": "PARAIBA",
    "PR": "PARANA",
    "PE": "PERNAMBUCO",
    "PI": "PIAUI",
    "RJ": "RIO DE JANEIRO",
    "RN": "RIO GRANDE DO NORTE",
    "RS": "RIO GRANDE DO SUL",
    "RO": "RONDONIA",
    "RR": "RORAIMA",
    "SC": "SANTA CATARINA",
    "SP": "SAO PAULO",
    "SE": "SERGIPE",
    "TO": "TOCANTINS",
  };

  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getCep(cep: string): Promise<Cep> {
    const normalizedCep = cep.replaceAll("-", "").replaceAll(".", "");
    if (normalizedCep.trim().length === 0) throw new Error('Falha ao buscar informções de CEP!');
    const response = await this.repository.getCep(normalizedCep);
    return { ...response, uf: this._dict[response.uf.toUpperCase() as keyof {}] ?? '' };
  }
}